import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export type ConfirmaModalObject = { message: string; _id: IProducto["_id"] };
export interface GeneralState {
  showCarrito: boolean;
  letThereBeLight: boolean;
  notification: boolean | string;
  confirmá: boolean | ConfirmaModalObject;
  openEditPhoto: {
    show: boolean;
    _id: string;
  };
}

const initialStateGeneralSlice: GeneralState = {
  showCarrito: false,
  letThereBeLight: false,
  notification: false,
  confirmá: false,
  openEditPhoto: { show: false, _id: "" },
};

const generalSlice = createSlice({
  name: "general",

  initialState: initialStateGeneralSlice,

  reducers: {
    /**
     * Opens and close the carrito overlay on the right side
     */
    changeShowCarrito(state, action: PayloadAction<boolean | undefined>) {
      //al apretar comprar en Main le paso un true, p/q se abra el carrito
      state.showCarrito = action.payload || !state.showCarrito;
    },

    changeTheme(state, action: PayloadAction<void>) {
      state.letThereBeLight = !state.letThereBeLight;
    },

    showOrCloseNotification(
      state,
      action: PayloadAction<
        | {
            show: true;
            message: string;
          }
        | { show: false }
      >
    ) {
      if (action.payload.show) {
        state.notification = action.payload.message;
        return;
      }
      state.notification = false;
    },
    confirmAction(
      state,
      action: PayloadAction<
        | ({
            show: true;
          } & ConfirmaModalObject)
        | { show: false }
      >
    ) {
      if (action.payload.show) {
        state.confirmá = action.payload;
        return;
      }
      state.confirmá = false;
    },
    hideOrShowEditPhotoOverlay(
      state,
      action: PayloadAction<
        | {
            show: true;
            _id: string;
          }
        | { show: false }
      >
    ) {
      if (action.payload.show) {
        state.openEditPhoto = action.payload;
        return;
      }
      state.openEditPhoto = { show: false, _id: "" };
    },
  },
});

export const {
  changeTheme,
  changeShowCarrito,
  showOrCloseNotification,
  confirmAction,
  hideOrShowEditPhotoOverlay,
} = generalSlice.actions;

export default generalSlice.reducer;
